import { useState } from "react";
import SectionHeading from "./SectionHeading.jsx";
import { faqItems } from "./data.js";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-white px-4 py-20 sm:px-6 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          eyebrow="Questions Answered"
          title="Questions?"
          highlight="Answered."
          centered
        />

        <div className="mt-12 rounded-[28px] border border-purple-100 bg-white">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={item.question}
                className={`border-b border-purple-100 last:border-b-0 ${isOpen ? "bg-[#fcfbff]" : ""
                  }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left sm:px-8"
                >
                  <span className="text-base font-bold font-montserrat text-[#0d0828] sm:text-lg">
                    {item.question}
                  </span>
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-full text-lg font-semibold transition ${isOpen
                      ? "rotate-45 bg-gradient-to-r from-purple-600 to-indigo-600 text-white"
                      : "bg-purple-50 text-purple-600"
                      }`}
                  >
                    +
                  </span>
                </button>

                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                    }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 font-montserrat text-sm leading-7 text-[#0d0828b3] sm:px-8 sm:text-base">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
